import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260217_casework_vertical_datum_anchor",
  description: "Migrate CaseworkVerticalDatum values to CaseworkVerticalDatumAnchor",
  apply(json: any): any {
    const datumMapping: Record<string, string> = {
      LEVEL: "LEVEL_FLOOR_ELEVATION",
      FLOOR_ELEVATION: "ROOM_FLOOR_ELEVATION",
      GRADE: "LEVEL_GRADE",
      CEILING_HEIGHT: "LEVEL_CEILING_HEIGHT",
    };

    if (json.casework) {
      for (const casework of Object.values(json.casework)) {
        const entity = casework as { verticalDatum?: string };
        if (entity.verticalDatum) {
          if (datumMapping[entity.verticalDatum]) {
            entity.verticalDatum = datumMapping[entity.verticalDatum];
          }
        }
      }
    }

    return json;
  },
};

export default migration;
